import Cookies from 'js-cookie';
import { getTicAuthExpirationMinutes } from '../api/api.environment.utils';

const COOKIE_NAME = '_tic_jwt';
const COOKIE_NAME_CLIENT_SESSION_SIGNAL = 'tic-session-valid';

import { DateTime } from 'luxon';

const cookieOptions = {
  secure: process.env.NODE_ENV !== 'development',
  sameSite: 'lax' as const,
  expires: 1 / 24, // 1 hour
};

export const setJwtCookie = (jwt: string) => {
  Cookies.set(COOKIE_NAME, jwt, cookieOptions);
};

export const getJwtCookie = () => {
  return Cookies.get(COOKIE_NAME);
};

/**
 * Sets a cookie (client-side) that mirrors the expiration of httpOnly session cookie
 * so we have a way to check if the session is still valid.
 * @param expirationMinutes
 */
export const setClientSessionSignalCookie = (expirationMinutes?: number) => {
  const expMinutes = expirationMinutes || getTicAuthExpirationMinutes();
  return Cookies.set(COOKIE_NAME_CLIENT_SESSION_SIGNAL, 'true', {
    expires: DateTime.now()
      .plus({ minutes: expMinutes - 1 }) // 1 minute before the actual expiration
      .toJSDate(),
  });
};

export const hasValidClientSessionSignalCookie = () => {
  return !!Cookies.get(COOKIE_NAME_CLIENT_SESSION_SIGNAL);
};
